// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sc-home {
    color-scheme: light;
    --ink: #13223e;
    --ink2: #283c58;
    --muted: #63738b;
    --blue: #165da8;
    --blue-2: #0b4c91;
    --cyan: #177fa6;
    --teal: #0d827d;
    --purple: #436aa7;
    --line: #e4eaf4;
    --paper: #fff;
    --wash: #f7f9fd;
    --shadow: 0 18px 60px rgba(28, 57, 102, .08);
    --radius: 22px;
    --content: 1160px
}

.sc-home * {
    box-sizing: border-box
}

.sc-home {
    scroll-behavior: smooth;
    scroll-padding-top: 18px
}

.sc-home {
    margin: 0;
    background: var(--paper);
    font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    color: var(--ink);
    line-height: 1.58;
    -webkit-font-smoothing: antialiased
}

.sc-home a {
    color: var(--blue-2);
    text-decoration: none
}

.sc-home a:hover {
    text-decoration: underline
}

.sc-home button {
    font: inherit
}

.sc-home svg {
    max-width: 100%
}

.sc-home img {
    max-width: 100%;
    height: auto;
    display: block
}

.sc-home .sc-container {
    width: min(var(--content), calc(100% - 48px));
    margin-inline: auto
}

























.sc-home .sc-cta {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    justify-content: center;
    border-radius: 12px;
    padding: 12px 19px;
    border: 1px solid transparent;
    font-size: 13px;
    font-weight: 730;
    text-decoration: none !important;
    white-space: nowrap;
    transition: transform .2s, box-shadow .2s, background .2s;
    cursor: pointer
}

.sc-home .sc-cta:hover {
    transform: translateY(-2px)
}

.sc-home .sc-cta.primary {
    color: white;
    background: linear-gradient(115deg, #0c509b, #186ba7);
    box-shadow: 0 11px 25px rgba(43, 93, 207, .20)
}

.sc-home .sc-cta.primary:hover {
    box-shadow: 0 14px 28px rgba(43, 93, 207, .27)
}

.sc-home .sc-cta.secondary {
    color: var(--blue-2);
    border-color: #cfddf0;
    background: white
}

.sc-home .sc-cta.small {
    padding: 9px 14px;
    font-size: 12px
}















.sc-home h1,
.sc-home h2,
.sc-home h3,
.sc-home p {
    margin-top: 0
}

.sc-home h1 {
    font-size: clamp(45px, 5.0vw, 72px);
    letter-spacing: -3.7px;
    line-height: 1.065;
    font-weight: 820;
    margin: 24px 0 23px
}

.sc-home h1 .gradient {
    background: linear-gradient(95deg, #163968 10%, #145da1 48%, #137e8a 90%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent
}

























.sc-home .stats-wrap {
    padding: 20px 0;
    background: #f8fafd;
    border-top: 1px solid #edf1f7;
    border-bottom: 1px solid #eaf0f8
}

.sc-home .stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr))
}

.sc-home .stat {
    padding: 14px 22px;
    border-right: 1px solid #dde5f1
}

.sc-home .stat:first-child {
    padding-left: 0
}

.sc-home .stat:last-child {
    border: none
}

.sc-home .stat strong {
    font-size: 25px;
    letter-spacing: -1.1px;
    display: block;
    color: #16335d;
    line-height: 1.15
}

.sc-home .stat span {
    font-size: 11px;
    color: #62748b;
    margin-top: 5px;
    display: block
}

.sc-home .stats-caption {
    text-align: right;
    font-size: 10px;
    color: #93a0b1;
    margin-top: 8px
}

.sc-home .sc-section {
    padding: 103px 0
}

.sc-home .sc-section.wash {
    background: #f8fafd
}

.sc-home .sc-section.hero {
    background: radial-gradient(ellipse at 96% 15%, rgba(153, 220, 247, .2), transparent 48%), radial-gradient(ellipse at 10% 94%, rgba(217, 233, 248, .24), transparent 45%), #fff
}

.sc-home .sc-section.compact {
    padding: 78px 0
}

/* Section intro is a self-contained vertical stack.  Do not reuse the
   generic \`section-heading\` class: app-wide styles may render it as a
   horizontal grid and place the heading underneath the following cards. */
.sc-home .sc-section-heading {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    row-gap: 13px;
    width: 100%;
    max-width: 790px;
    min-width: 0;
    min-height: 0;
    height: auto;
    max-height: none;
    margin: 0 0 38px;
    padding: 0;
    float: none;
    clear: both;
    overflow: visible;
    text-align: left;
}
.sc-home .sc-section-heading--center {
    margin-inline: auto;
    text-align: center;
    align-items: center;
}
.sc-home .sc-section-heading > .kicker {
    display: block;
    order: 0;
    width: auto;
    max-width: 100%;
    margin: 0;
    padding: 0;
    position: static;
    float: none;
    line-height: 1.5;
    white-space: normal;
}
.sc-home .sc-section-heading > h2 {
    display: block;
    order: 1;
    position: static;
    float: none;
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    font-size: clamp(27px, 4.0cqw, 43px);
    font-weight: 800;
    line-height: 1.19;
    letter-spacing: -.037em;
    text-wrap: balance;
    overflow-wrap: break-word;
    white-space: normal;
}
.sc-home .sc-section-heading > p.lead {
    display: block;
    order: 2;
    position: static;
    float: none;
    width: 100%;
    max-width: 750px;
    height: auto;
    flex: 0 0 auto;
    margin: 0;
    padding: 0;
    font-size: clamp(13px, 1.65cqw, 16px);
    line-height: 1.75;
    white-space: normal;
    overflow-wrap: break-word;
}


.sc-home .kicker {
    color: #236fc8;
    text-transform: uppercase;
    letter-spacing: 2.6px;
    font-size: 10px;
    font-weight: 830;
    margin-bottom: 14px;
    display: block
}

.sc-home h2 {
    font-size: clamp(31px, 3.3vw, 45px);
    letter-spacing: -1.8px;
    line-height: 1.16;
    font-weight: 800;
    margin-bottom: 16px
}

.sc-home .lead {
    font-size: 15px;
    color: #65758b;
    line-height: 1.8;
    margin-bottom: 0
}

.sc-home .two-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px
}

.sc-home .persona {
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 22px;
    padding: 31px 32px 27px;
    box-shadow: 0 8px 34px rgba(40, 80, 128, .04);
    position: relative;
    overflow: hidden
}

.sc-home .persona:before {
    content: "";
    height: 4px;
    background: linear-gradient(90deg, #0bbfae, #4a9ae9);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%
}

.sc-home .persona.purple:before {
    background: linear-gradient(90deg, #426cae, #2a899a)
}

.sc-home .persona-icon {
    height: 49px;
    width: 49px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e7f8f5;
    color: #099c92;
    margin-bottom: 20px;
    font-size: 22px
}

.sc-home .persona.purple .persona-icon {
    background: #eaf2fc;
    color: #3b66a0
}

.sc-home .persona h3 {
    font-size: 22px;
    letter-spacing: -.6px;
    margin-bottom: 10px
}

.sc-home .persona p {
    color: var(--muted);
    font-size: 13px;
    line-height: 1.85;
    margin-bottom: 20px
}

.sc-home .link-inline {
    font-size: 12px;
    font-weight: 750
}

.sc-home .persona.purple .link-inline {
    color: #285d9d
}

.sc-home .feature-bar {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    margin-top: 18px
}

.sc-home .feature-mini {
    display: flex;
    gap: 12px;
    padding: 19px;
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 15px;
    align-items: flex-start
}

.sc-home .feature-mini .symbol {
    font-size: 20px;
    line-height: 1.2
}

.sc-home .feature-mini strong {
    display: block;
    font-size: 12px;
    margin-bottom: 3px
}

.sc-home .feature-mini span {
    font-size: 11px;
    line-height: 1.6;
    color: #79879a;
    display: block
}

.sc-home .fig-wrap {
    margin: 0;
    border: 1px solid #e2e9f4;
    background: white;
    padding: 10px;
    border-radius: 22px;
    box-shadow: var(--shadow)
}

.sc-home .fig-wrap img {
    width: 100%;
    height: auto;
    aspect-ratio: auto;
    border-radius: 14px;
    object-fit: contain
}

.sc-home .fig-wrap figcaption {
    color: #617188;
    font-size: 12px;
    line-height: 1.8;
    padding: 15px 14px 10px
}

.sc-home .fig-wrap figcaption strong {
    color: #234167
}

.sc-home .fig-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px
}

.sc-home .figure-label {
    margin-bottom: 15px;
    color: #4e6480;
    font-size: 14px;
    font-weight: 700
}

.sc-home .motion-panel {
    background: linear-gradient(135deg, #ffffff, #f9fcff);
    border: 1px solid #e1eaf7;
    border-radius: 26px;
    box-shadow: var(--shadow);
    padding: 30px;
    position: relative;
    overflow: hidden
}

.sc-home .motion-toolbar {
    display: flex;
    gap: 14px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 24px
}

.sc-home .segment {
    padding: 5px;
    display: inline-flex;
    gap: 3px;
    border-radius: 12px;
    background: #ecf2fa;
    max-width: 100%
}

.sc-home .segment button {
    border: 0;
    cursor: pointer;
    background: transparent;
    color: #687b95;
    padding: 10px 17px;
    font-size: 12px;
    font-weight: 740;
    border-radius: 9px;
    transition: background .2s
}

.sc-home .segment button[aria-selected="true"] {
    background: white;
    color: #2069bc;
    box-shadow: 0 2px 10px #d4e0f0
}

.sc-home .motion-caption {
    font-size: 12px;
    color: #8a9aaf
}

.sc-home .pause-btn {
    border: 1px solid #dbe5f0;
    background: #fff;
    padding: 8px 13px;
    font-size: 12px;
    font-weight: 700;
    color: #47647d;
    border-radius: 10px;
    cursor: pointer
}

.sc-home .flow-nodes {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    align-items: stretch
}

.sc-home .flow-node {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    min-height: 133px;
    border: 1px solid #dfe8f5;
    border-radius: 17px;
    background: #fff;
    padding: 14px 8px;
    transition: border .25s, transform .25s, box-shadow .25s, background .25s;
    cursor: pointer
}

.sc-home .flow-node.active {
    border-color: #6ba9e7;
    background: linear-gradient(160deg, #fff, #eff8ff);
    box-shadow: 0 8px 30px rgba(44, 123, 219, .15);
    transform: translateY(-4px)
}

.sc-home .flow-node.active:before {
    content: "";
    position: absolute;
    height: 3px;
    background: linear-gradient(90deg, #41a4e9, #20b9b6);
    left: 20px;
    right: 20px;
    top: 0;
    border-radius: 5px
}

.sc-home .flow-node:not(:last-child):after {
    content: "→";
    font-size: 19px;
    color: #68a5de;
    position: absolute;
    right: -17px;
    top: 43%;
    z-index: 3;
    font-weight: 800
}

.sc-home .flow-icon {
    height: 45px;
    width: 45px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eff5fe;
    color: #267acc;
    font-size: 21px;
    margin-bottom: 10px;
    transition: background .2s
}

.sc-home .flow-node.active .flow-icon {
    background: #d5ecfe
}

.sc-home .flow-node strong {
    display: block;
    font-size: 12px;
    color: #20334e
}

.sc-home .flow-node small {
    font-size: 10px;
    color: #91a0b1;
    margin-top: 4px
}

.sc-home .motion-detail {
    margin-top: 22px;
    background: #f1f7ff;
    border: 1px solid #e2eefc;
    border-radius: 14px;
    min-height: 66px;
    padding: 18px 20px;
    color: #526d8e;
    font-size: 13px;
    display: flex;
    gap: 18px;
    align-items: center
}

.sc-home .motion-detail strong {
    color: #215793;
    white-space: nowrap
}

.sc-home .motion-detail span {
    flex: 1 1
}

.sc-home .tiny-note {
    font-size: 11px;
    color: #8493a6;
    margin-top: 14px;
    margin-bottom: 0
}

.sc-home .steps-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 14px
}

.sc-home .step {
    border: 1px solid var(--line);
    border-radius: 18px;
    background: #fff;
    padding: 20px 17px;
    box-shadow: 0 4px 17px rgba(46, 80, 123, .04);
    position: relative
}

.sc-home .step-num {
    font-size: 11px;
    letter-spacing: 1px;
    color: #3583c9;
    background: #e8f3ff;
    border-radius: 9px;
    display: inline-flex;
    padding: 7px 10px;
    font-weight: 760;
    margin-bottom: 16px
}

.sc-home .step h3 {
    font-size: 15px;
    letter-spacing: -.2px;
    line-height: 1.4;
    margin: 0 0 8px
}

.sc-home .step p {
    font-size: 12px;
    color: #6e7e94;
    line-height: 1.75;
    margin: 0
}

.sc-home .code-panel {
    border: 1px solid #dce7f4;
    border-radius: 18px;
    overflow: hidden;
    background: #102039;
    margin-top: 28px;
    color: #e9f5ff;
    box-shadow: 0 18px 34px rgba(25, 53, 100, .12)
}

.sc-home .code-head {
    background: #1a2b49;
    padding: 12px 18px;
    border-bottom: 1px solid #314766;
    font-size: 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #b0c5e4
}

.sc-home .code-dots {
    display: flex;
    gap: 6px
}

.sc-home .code-dots i {
    background: #6594d0;
    width: 7px;
    height: 7px;
    border-radius: 50%
}

.sc-home .code-panel pre {
    font-size: 13px;
    line-height: 1.8;
    white-space: pre-wrap;
    padding: 20px 24px;
    overflow: auto;
    margin: 0;
    font-family: "SFMono-Regular", Consolas, monospace
}

.sc-home .code-panel .kw {
    color: #82d6fa
}

.sc-home .code-panel .string {
    color: #adf1cf
}

.sc-home .copy-btn {
    background: transparent;
    border: 1px solid #52708e;
    border-radius: 7px;
    color: #d1e8f7;
    padding: 5px 9px;
    cursor: pointer;
    font-size: 11px
}

.sc-home .guides {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 15px
}

.sc-home .guide {
    display: block;
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 16px;
    padding: 21px;
    transition: transform .2s, box-shadow .2s;
    min-height: 132px
}

.sc-home .guide:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(33, 76, 125, .1);
    text-decoration: none
}

.sc-home .guide-icon {
    font-size: 21px;
    display: block;
    margin-bottom: 13px
}

.sc-home .guide strong {
    display: block;
    font-size: 14px;
    color: var(--ink)
}

.sc-home .guide small {
    display: block;
    margin-top: 6px;
    font-size: 11px;
    color: #8090a4;
    line-height: 1.7
}

.sc-home .bottomband {
    padding: 75px 0;
    background: radial-gradient(ellipse at 76% 20%, #eef2ff, transparent 54%), linear-gradient(125deg, #f4fbff, #fbfaff);
    border-top: 1px solid #e8edf7;
    border-bottom: 1px solid #e8edf7;
    text-align: center
}

.sc-home .bottomband h2 {
    font-size: 36px
}

.sc-home .bottomband .lead {
    max-width: 650px;
    margin: 0 auto 24px
}

.sc-home .footer {
    padding: 30px 0 44px;
    color: #8a9bad;
    font-size: 11px
}

.sc-home .footer-flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px
}





@container sc-home (max-width: 960px) {
    .sc-home .hero-grid {
        gap: 28px
    }

    .sc-home .hero-art {
        height: 380px
    }

    .sc-home .feature-bar {
        grid-template-columns: 1fr 1fr
    }

    .sc-home .steps-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }

    .sc-home .nav-links {
        gap: 17px
    }
}

@container sc-home (max-width: 640px) {
    .sc-home .fig-grid {
        grid-template-columns: minmax(0, 1fr);
    }
}

@container sc-home (max-width: 730px) {
    .sc-home .hero {
        padding: 66px 0
    }

    .sc-home .hero-grid {
        grid-template-columns: 1fr
    }

    .sc-home .hero-art {
        max-width: 600px;
        width: 100%;
        margin: auto
    }

    .sc-home .two-cards {
        grid-template-columns: 1fr
    }

    .sc-home .feature-bar {
        grid-template-columns: 1fr
    }

    .sc-home .nav-links {
        display: none;
        position: absolute;
        top: 77px;
        right: 0;
        left: 0;
        background: white;
        border-bottom: 1px solid var(--line);
        padding: 19px 24px;
        box-shadow: var(--shadow);
        flex-direction: column;
        align-items: stretch;
        z-index: 10
    }

    .sc-home .nav-links.open {
        display: flex
    }

    .sc-home .mobile-menu {
        display: flex
    }

    .sc-home .stats {
        grid-template-columns: 1fr 1fr
    }

    .sc-home .stat:nth-child(2) {
        border-right: 0
    }

    .sc-home .stat:nth-child(-n + 2) {
        border-bottom: 1px solid #e1e9f3
    }

    .sc-home .stat:nth-child(3) {
        padding-left: 0
    }

    .sc-home .sc-section {
        padding: 75px 0
    }

    .sc-home .guides {
        grid-template-columns: 1fr 1fr
    }

    .sc-home .flow-nodes {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }

    .sc-home .flow-node:not(:last-child):after {
        display: none
    }
}

@container sc-home (max-width: 490px) {
    .sc-home .sc-container {
        width: min(var(--content), calc(100% - 32px))
    }

    .sc-home h1 {
        font-size: 45px;
        letter-spacing: -2.1px
    }

    .sc-home .hero-art {
        height: 300px
    }

    .sc-home .float-card {
        transform: scale(.82) !important
    }

    .sc-home .float-card.top {
        left: 7px;
        top: 18px
    }

    .sc-home .float-card.bottom {
        right: 7px;
        bottom: 12px
    }

    .sc-home .hero-intro {
        font-size: 15px
    }

    .sc-home .stats-caption {
        text-align: center
    }

    .sc-home .stat {
        padding: 15px
    }

    .sc-home .stat strong {
        font-size: 22px
    }

    .sc-home .motion-panel {
        padding: 19px 12px
    }

    .sc-home .segment {
        width: 100%
    }

    .sc-home .segment button {
        padding: 9px 8px;
        font-size: 11px;
        flex: 1 1
    }

    .sc-home .motion-toolbar {
        justify-content: center
    }

    .sc-home .flow-nodes {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }

    .sc-home .flow-node {
        min-height: 114px
    }

    .sc-home .motion-detail {
        flex-direction: column;
        align-items: flex-start;
        gap: 7px
    }

    .sc-home .steps-grid {
        grid-template-columns: 1fr 1fr
    }

    .sc-home .guides {
        grid-template-columns: 1fr
    }

    .sc-home .fig-wrap {
        padding: 5px
    }

    .sc-home .fig-wrap figcaption {
        padding: 12px
    }

    .sc-home .bottomband h2 {
        font-size: 30px
    }

    .sc-home .sc-cta {
        padding: 11px 15px;
        font-size: 12px
    }
}

@media (prefers-reduced-motion:reduce) {

    .sc-home *,
    .sc-home *:before,
    .sc-home *:after {
        animation: none !important;
        transition: none !important;
        scroll-behavior: auto !important
    }
}

/* Host page integration: never change surrounding right/left rail layout. */
.sc-home {
    max-width: 100%;
    min-width: 0;
    width: 100%;
    overflow-x: clip;
    background: white;
    font-size: 16px;
}

.sc-home .sc-container {
    width: min(var(--content), calc(100% - 36px));
}

.sc-home figure {
    margin-block: 0;
}

.sc-home .fig-wrap img {
    image-rendering: auto;
    width: 100%;
    max-width: 100%;
    height: auto;
    object-fit: contain;
}



.sc-home section[id] {
    scroll-margin-top: 20px;
}

.sc-home button:focus-visible,
.sc-home a:focus-visible {
    outline: 3px solid #2895c6;
    outline-offset: 3px;
}

@container sc-home (max-width: 650px) {
    .sc-home .sc-container {
        width: calc(100% - 28px);
    }
}

/* ======================================================================
   APP.CSS / NAVBAR.CSS INTEGRATION FIXES
   These declarations affect only getStarted.js; other page styles remain intact.
   All layout breakpoints above are container queries, based on THIS page's
   actual width, not the full browser viewport.
   ====================================================================== */
.sc-home {
    /* This page can be rendered inside a narrow grid column. */
    container: sc-home / inline-size;
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    height: auto;
    isolation: isolate;
    overflow-x: clip;
    color: #13223e;
    background: #fff;
    text-align: left;
}

.sc-home .sc-container {
    /* NEVER use App.css' generic .container: its height:100vh caused
       enormous empty spaces and layout overflow on every section. */
    display: block;
    position: relative;
    width: min(100% - 36px, var(--content));
    max-width: 100%;
    min-height: 0;
    height: auto;
    margin-inline: auto;
    padding: 0;
}

.sc-home .sc-section {
    display: block;
    min-width: 0;
    width: 100%;
    height: auto;
    padding-block: clamp(36px, 5cqw, 72px);
}

.sc-home main {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: block;
    margin: 0;
    padding: 0;
    height: auto;
}

.sc-home .two-cards,
.sc-home .feature-bar,
.sc-home .fig-grid,
.sc-home .steps-grid,
.sc-home .guides,
.sc-home .flow-nodes {
    min-width: 0;
}

.sc-home .two-cards > *,
.sc-home .feature-bar > *,
.sc-home .fig-grid > *,
.sc-home .steps-grid > *,
.sc-home .guides > *,
.sc-home .flow-nodes > * {
    min-width: 0;
}

.sc-home .fig-grid {
    /* Figures share the row at desktop/content widths; image links allow full-size inspection. */
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    max-width: none;
    margin-inline: 0;
    align-items: stretch;
    gap: 20px;
}

.sc-home .fig-wrap {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    overflow: hidden;
}

.sc-home .fig-wrap img {
    /* Remove the old wrong 745:402 aspect ratio; actual files are 4:3. */
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: none;
    aspect-ratio: auto;
    object-fit: contain;
    margin: 0 auto;
}

.sc-home .sc-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 19px;
    gap: 8px;
    text-decoration: none;
    font-weight: 730;
    font-size: 13px;
    line-height: 1.5;
    border: 1px solid transparent;
    border-radius: 12px;
    cursor: pointer;
    white-space: normal;
}
.sc-home .sc-cta.primary {
    color: #fff;
    background: linear-gradient(115deg, #0c509b, #186ba7);
    box-shadow: 0 11px 25px rgba(43, 93, 207, .2);
}
.sc-home .sc-cta.primary:hover {
    color: #fff;
    text-decoration: none;
    box-shadow: 0 14px 28px rgba(43, 93, 207, .27);
}

/* App.css styles .main-content pre and code for Markdown pages. Ensure
   this native JSX code example retains its intentional dark styling. */
.sc-home .code-panel pre {
    display: block;
    background: transparent;
    color: #e9f5ff;
    border: 0;
    border-radius: 0;
    margin: 0;
    padding: 20px 24px;
    max-width: 100%;
    overflow-x: auto;
    overflow-wrap: normal;
    white-space: pre;
    font-size: 13px;
    line-height: 1.8;
}
.sc-home .code-panel pre code {
    color: inherit;
    background: transparent;
    border: 0;
    padding: 0;
    font: inherit;
    white-space: inherit;
}
.sc-home .code-panel .kw { color: #82d6fa; }
.sc-home .code-panel .string { color: #adf1cf; }

/* Use actual component width; a 1200px browser may provide only 700px
   to this page after the surrounding navigation rails are laid out. */
@container sc-home (max-width: 1040px) {
    .sc-home .steps-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    .sc-home .feature-bar { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@container sc-home (max-width: 780px) {
    .sc-home .two-cards { grid-template-columns: minmax(0, 1fr); }
    .sc-home .feature-bar { grid-template-columns: minmax(0, 1fr); }
    .sc-home .flow-nodes { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    .sc-home .flow-node:not(:last-child):after { display: none; }
    .sc-home .steps-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .sc-home .guides { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .sc-home .motion-panel { padding: 20px; }
    .sc-home .sc-container { width: calc(100% - 28px); }
}
@container sc-home (max-width: 500px) {
    .sc-home .steps-grid { grid-template-columns: minmax(0, 1fr); }
    .sc-home .guides { grid-template-columns: minmax(0, 1fr); }
    .sc-home .flow-nodes { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .sc-home .fig-wrap { padding: 5px; }
    .sc-home .fig-wrap figcaption { padding: 12px; }
    .sc-home .segment { width: 100%; }
    .sc-home .segment button { flex: 1 1 auto; min-width: 0; padding: 9px 7px; }
    .sc-home .motion-toolbar { justify-content: center; }
    .sc-home .motion-detail { display: block; }
    .sc-home .motion-detail strong { display: block; margin-bottom: 8px; white-space: normal; }
    .sc-home .sc-container { width: calc(100% - 24px); }
    .sc-home .code-panel pre { padding: 14px; font-size: 11px; }
}

/* When the existing three-column Get Started shell is used on narrow
   screens, its 15% / 65% / 20% grid leaves too little space for the page.
   Affect ONLY the shell containing this component; other routes and the
   shared navbar remain unchanged. */
@media (max-width: 900px) {
    .getStarted-container:has(.sc-home) {
        grid-template-columns: minmax(0, 1fr);
    }
    .getStarted-container:has(.sc-home) > .left-nav,
    .getStarted-container:has(.sc-home) > .right-rail {
        display: none;
    }
    .getStarted-container:has(.sc-home) > .main-content,
    .getStarted-container:has(.sc-home) > .main-content-no-scroll {
        min-width: 0;
        padding: 12px;
        overflow-x: clip;
    }
}

/* Keep headings and subsequent content separate at every host width.
   All selectors are scoped; App.css and navbar.css remain untouched. */
.sc-home .sc-section-heading + .two-cards,
.sc-home .sc-section-heading + .fig-grid,
.sc-home .sc-section-heading + .motion-panel,
.sc-home .sc-section-heading + .steps-grid,
.sc-home .sc-section-heading + .guides,
.sc-home .sc-section-heading + .fig-wrap {
    position: relative;
    clear: both;
    min-width: 0;
}
@container sc-home (max-width: 600px) {
    .sc-home .sc-section-heading { row-gap: 11px; margin-bottom: 25px; }
    .sc-home .sc-section-heading > h2 { font-size: clamp(24px, 5.1cqw, 34px); }
    .sc-home .sc-section-heading > p.lead { font-size: 13px; }
}

/* Platform diagrams: two equal columns in the existing main-content region.
   Breakpoints use the page container's width, so the host's left/right rails
   do not cause accidental side-by-side overflow. */
.sc-home #architecture .fig-grid.fig-grid--side-by-side {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
    gap: clamp(12px, 2cqw, 24px);
    width: 100%;
    max-width: none;
}
.sc-home #architecture .fig-grid--side-by-side > .fig-wrap {
    min-width: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
}
.sc-home #architecture .fig-grid--side-by-side .fig-image-link {
    display: block;
    width: 100%;
    border-radius: 14px;
    overflow: hidden;
}
.sc-home #architecture .fig-grid--side-by-side .fig-image-link img {
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
}
.sc-home #architecture .fig-grid--side-by-side figcaption {
    flex: 1 1;
}
@container sc-home (max-width: 640px) {
    .sc-home #architecture .fig-grid.fig-grid--side-by-side {
        grid-template-columns: minmax(0, 1fr);
    }
}


/* Python code example: preserve intentional line breaks from React text nodes,
   avoid host Markdown/pre styling, and keep Copy usable on small screens. */
.sc-home .code-panel {
    min-width: 0;
    max-width: 100%;
}

.sc-home .code-panel .code-head {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    min-width: 0;
}

.sc-home .code-panel .code-title {
    min-width: 0;
    text-align: center;
    overflow-wrap: anywhere;
}

.sc-home .code-panel .code-dots {
    flex-shrink: 0;
}

.sc-home .code-panel pre.sc-code-pre {
    display: block;
    min-width: 0;
    max-width: 100%;
    padding: 18px 24px;
    margin: 0;
    overflow-x: auto;
    overflow-y: hidden;
    background: transparent;
    color: #e9f5ff;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
    font-size: 13px;
    line-height: 1.9;
    white-space: pre;
    word-break: normal;
    overflow-wrap: normal;
    tab-size: 4;
}

.sc-home .code-panel pre.sc-code-pre code.sc-code-text {
    display: block;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    color: inherit;
    font: inherit;
    white-space: pre;
    word-break: normal;
    overflow-wrap: normal;
    user-select: text;
    -webkit-user-select: text;
}

.sc-home .code-panel pre.sc-code-pre .kw { color: #82d6fa; }
.sc-home .code-panel pre.sc-code-pre .string { color: #adf1cf; }

.sc-home .code-panel .copy-btn {
    min-width: 78px;
    min-height: 34px;
    padding: 7px 12px;
    white-space: nowrap;
    font: inherit;
    font-size: 12px;
    line-height: 1.4;
    cursor: pointer;
    background-color: #203a5b;
    color: #e9f5ff;
}
.sc-home .code-panel .copy-btn:hover { background-color: #2d507c; }
.sc-home .code-panel .copy-btn:focus-visible {
    outline: 2px solid #8ad5ff;
    outline-offset: 2px;
}

@container sc-home (max-width: 540px) {
    .sc-home .code-panel .code-head {
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 8px;
        padding: 12px;
    }
    .sc-home .code-panel .code-dots { display: none; }
    .sc-home .code-panel .code-title { text-align: left; }
    .sc-home .code-panel pre.sc-code-pre {
        padding: 16px 14px;
        font-size: 11px;
    }
    .sc-home .code-panel .copy-btn {
        padding: 7px 9px;
        min-width: 56px;
        font-size: 11px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/getStarted.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,eAAe;IACf,4CAA4C;IAC5C,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,wBAAwB;IACxB,4FAA4F;IAC5F,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,6CAA6C;IAC7C;AACJ;;;;;;;;;;;;;;;;;;;;;;;;;;AA0BA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,yDAAyD;IACzD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,qDAAqD;IACrD;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;;;;;;;;;;;;;;;AAgBA;;;;IAII;AACJ;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yEAAyE;IACzE,6BAA6B;IAC7B,qBAAqB;IACrB;AACJ;;;;;;;;;;;;;;;;;;;;;;;;;;AA0BA;IACI,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;0EAE0E;AAC1E;IACI,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,QAAQ;IACR,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,SAAS;IACT,UAAU;IACV,qCAAqC;IACrC,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;IAC7C,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oDAAoD;IACpD,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yEAAyE;IACzE;AACJ;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;IAClD,8CAA8C;IAC9C;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,oDAAoD;IACpD,UAAU;IACV,WAAW;IACX,MAAM;IACN;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,UAAU;IACV;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC;AACJ;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,oHAAoH;IACpH,6BAA6B;IAC7B,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf;AACJ;;;;;;AAMA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,OAAO;QACP,iBAAiB;QACjB,oCAAoC;QACpC,kBAAkB;QAClB,yBAAyB;QACzB,sBAAsB;QACtB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;;IAEI;;;QAGI,0BAA0B;QAC1B,2BAA2B;QAC3B;IACJ;AACJ;;AAEA,4EAA4E;AAC5E;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;;AAIA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;;;;2EAK2E;AAC3E;IACI,2DAA2D;IAC3D,gCAAgC;IAChC,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;oEACgE;IAChE,cAAc;IACd,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;;;;;;IAMI,YAAY;AAChB;;AAEA;;;;;;IAMI,YAAY;AAChB;;AAEA;IACI,6FAA6F;IAC7F,gDAAgD;IAChD,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qEAAqE;IACrE,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,qDAAqD;IACrD,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;uEACuE;AACvE;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,aAAa;IACb,oBAAoB;AACxB;AACA,2BAA2B,cAAc,EAAE;AAC3C,+BAA+B,cAAc,EAAE;;AAE/C;sEACsE;AACtE;IACI,uBAAuB,gDAAgD,EAAE;IACzE,wBAAwB,gDAAgD,EAAE;AAC9E;AACA;IACI,sBAAsB,qCAAqC,EAAE;IAC7D,wBAAwB,qCAAqC,EAAE;IAC/D,uBAAuB,gDAAgD,EAAE;IACzE,6CAA6C,aAAa,EAAE;IAC5D,uBAAuB,gDAAgD,EAAE;IACzE,mBAAmB,gDAAgD,EAAE;IACrE,yBAAyB,aAAa,EAAE;IACxC,yBAAyB,wBAAwB,EAAE;AACvD;AACA;IACI,uBAAuB,qCAAqC,EAAE;IAC9D,mBAAmB,qCAAqC,EAAE;IAC1D,uBAAuB,gDAAgD,EAAE;IACzE,qBAAqB,YAAY,EAAE;IACnC,gCAAgC,aAAa,EAAE;IAC/C,oBAAoB,WAAW,EAAE;IACjC,2BAA2B,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE;IAC3E,2BAA2B,uBAAuB,EAAE;IACpD,0BAA0B,cAAc,EAAE;IAC1C,iCAAiC,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;IAC1F,yBAAyB,wBAAwB,EAAE;IACnD,2BAA2B,aAAa,EAAE,eAAe,EAAE;AAC/D;;AAEA;;;oCAGoC;AACpC;IACI;QACI,qCAAqC;IACzC;IACA;;QAEI,aAAa;IACjB;IACA;;QAEI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA;uEACuE;AACvE;;;;;;IAMI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,+BAA+B,aAAa,EAAE,mBAAmB,EAAE;IACnE,oCAAoC,oCAAoC,EAAE;IAC1E,wCAAwC,eAAe,EAAE;AAC7D;;AAEA;;mDAEmD;AACnD;IACI,aAAa;IACb,gDAAgD;IAChD,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,eAAe;AACnB;AACA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI;QACI,qCAAqC;IACzC;AACJ;;;AAGA;4EAC4E;AAC5E;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,qEAAqE;IACrE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,2CAA2C,cAAc,EAAE;AAC3D,+CAA+C,cAAc,EAAE;;AAE/D;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;AACA,uCAAuC,yBAAyB,EAAE;AAClE;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI;QACI,0CAA0C;QAC1C,QAAQ;QACR,aAAa;IACjB;IACA,kCAAkC,aAAa,EAAE;IACjD,mCAAmC,gBAAgB,EAAE;IACrD;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":[".sc-home {\n    color-scheme: light;\n    --ink: #13223e;\n    --ink2: #283c58;\n    --muted: #63738b;\n    --blue: #165da8;\n    --blue-2: #0b4c91;\n    --cyan: #177fa6;\n    --teal: #0d827d;\n    --purple: #436aa7;\n    --line: #e4eaf4;\n    --paper: #fff;\n    --wash: #f7f9fd;\n    --shadow: 0 18px 60px rgba(28, 57, 102, .08);\n    --radius: 22px;\n    --content: 1160px\n}\n\n.sc-home * {\n    box-sizing: border-box\n}\n\n.sc-home {\n    scroll-behavior: smooth;\n    scroll-padding-top: 18px\n}\n\n.sc-home {\n    margin: 0;\n    background: var(--paper);\n    font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    color: var(--ink);\n    line-height: 1.58;\n    -webkit-font-smoothing: antialiased\n}\n\n.sc-home a {\n    color: var(--blue-2);\n    text-decoration: none\n}\n\n.sc-home a:hover {\n    text-decoration: underline\n}\n\n.sc-home button {\n    font: inherit\n}\n\n.sc-home svg {\n    max-width: 100%\n}\n\n.sc-home img {\n    max-width: 100%;\n    height: auto;\n    display: block\n}\n\n.sc-home .sc-container {\n    width: min(var(--content), calc(100% - 48px));\n    margin-inline: auto\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.sc-home .sc-cta {\n    display: inline-flex;\n    align-items: center;\n    gap: 9px;\n    justify-content: center;\n    border-radius: 12px;\n    padding: 12px 19px;\n    border: 1px solid transparent;\n    font-size: 13px;\n    font-weight: 730;\n    text-decoration: none !important;\n    white-space: nowrap;\n    transition: transform .2s, box-shadow .2s, background .2s;\n    cursor: pointer\n}\n\n.sc-home .sc-cta:hover {\n    transform: translateY(-2px)\n}\n\n.sc-home .sc-cta.primary {\n    color: white;\n    background: linear-gradient(115deg, #0c509b, #186ba7);\n    box-shadow: 0 11px 25px rgba(43, 93, 207, .20)\n}\n\n.sc-home .sc-cta.primary:hover {\n    box-shadow: 0 14px 28px rgba(43, 93, 207, .27)\n}\n\n.sc-home .sc-cta.secondary {\n    color: var(--blue-2);\n    border-color: #cfddf0;\n    background: white\n}\n\n.sc-home .sc-cta.small {\n    padding: 9px 14px;\n    font-size: 12px\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.sc-home h1,\n.sc-home h2,\n.sc-home h3,\n.sc-home p {\n    margin-top: 0\n}\n\n.sc-home h1 {\n    font-size: clamp(45px, 5.0vw, 72px);\n    letter-spacing: -3.7px;\n    line-height: 1.065;\n    font-weight: 820;\n    margin: 24px 0 23px\n}\n\n.sc-home h1 .gradient {\n    background: linear-gradient(95deg, #163968 10%, #145da1 48%, #137e8a 90%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.sc-home .stats-wrap {\n    padding: 20px 0;\n    background: #f8fafd;\n    border-top: 1px solid #edf1f7;\n    border-bottom: 1px solid #eaf0f8\n}\n\n.sc-home .stats {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr))\n}\n\n.sc-home .stat {\n    padding: 14px 22px;\n    border-right: 1px solid #dde5f1\n}\n\n.sc-home .stat:first-child {\n    padding-left: 0\n}\n\n.sc-home .stat:last-child {\n    border: none\n}\n\n.sc-home .stat strong {\n    font-size: 25px;\n    letter-spacing: -1.1px;\n    display: block;\n    color: #16335d;\n    line-height: 1.15\n}\n\n.sc-home .stat span {\n    font-size: 11px;\n    color: #62748b;\n    margin-top: 5px;\n    display: block\n}\n\n.sc-home .stats-caption {\n    text-align: right;\n    font-size: 10px;\n    color: #93a0b1;\n    margin-top: 8px\n}\n\n.sc-home .sc-section {\n    padding: 103px 0\n}\n\n.sc-home .sc-section.wash {\n    background: #f8fafd\n}\n\n.sc-home .sc-section.hero {\n    background: radial-gradient(ellipse at 96% 15%, rgba(153, 220, 247, .2), transparent 48%), radial-gradient(ellipse at 10% 94%, rgba(217, 233, 248, .24), transparent 45%), #fff\n}\n\n.sc-home .sc-section.compact {\n    padding: 78px 0\n}\n\n/* Section intro is a self-contained vertical stack.  Do not reuse the\n   generic `section-heading` class: app-wide styles may render it as a\n   horizontal grid and place the heading underneath the following cards. */\n.sc-home .sc-section-heading {\n    position: relative;\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: flex-start;\n    justify-content: flex-start;\n    row-gap: 13px;\n    width: 100%;\n    max-width: 790px;\n    min-width: 0;\n    min-height: 0;\n    height: auto;\n    max-height: none;\n    margin: 0 0 38px;\n    padding: 0;\n    float: none;\n    clear: both;\n    overflow: visible;\n    text-align: left;\n}\n.sc-home .sc-section-heading--center {\n    margin-inline: auto;\n    text-align: center;\n    align-items: center;\n}\n.sc-home .sc-section-heading > .kicker {\n    display: block;\n    order: 0;\n    width: auto;\n    max-width: 100%;\n    margin: 0;\n    padding: 0;\n    position: static;\n    float: none;\n    line-height: 1.5;\n    white-space: normal;\n}\n.sc-home .sc-section-heading > h2 {\n    display: block;\n    order: 1;\n    position: static;\n    float: none;\n    flex: 0 0 auto;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    height: auto;\n    margin: 0;\n    padding: 0;\n    font-size: clamp(27px, 4.0cqw, 43px);\n    font-weight: 800;\n    line-height: 1.19;\n    letter-spacing: -.037em;\n    text-wrap: balance;\n    overflow-wrap: break-word;\n    white-space: normal;\n}\n.sc-home .sc-section-heading > p.lead {\n    display: block;\n    order: 2;\n    position: static;\n    float: none;\n    width: 100%;\n    max-width: 750px;\n    height: auto;\n    flex: 0 0 auto;\n    margin: 0;\n    padding: 0;\n    font-size: clamp(13px, 1.65cqw, 16px);\n    line-height: 1.75;\n    white-space: normal;\n    overflow-wrap: break-word;\n}\n\n\n.sc-home .kicker {\n    color: #236fc8;\n    text-transform: uppercase;\n    letter-spacing: 2.6px;\n    font-size: 10px;\n    font-weight: 830;\n    margin-bottom: 14px;\n    display: block\n}\n\n.sc-home h2 {\n    font-size: clamp(31px, 3.3vw, 45px);\n    letter-spacing: -1.8px;\n    line-height: 1.16;\n    font-weight: 800;\n    margin-bottom: 16px\n}\n\n.sc-home .lead {\n    font-size: 15px;\n    color: #65758b;\n    line-height: 1.8;\n    margin-bottom: 0\n}\n\n.sc-home .two-cards {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px\n}\n\n.sc-home .persona {\n    background: #fff;\n    border: 1px solid var(--line);\n    border-radius: 22px;\n    padding: 31px 32px 27px;\n    box-shadow: 0 8px 34px rgba(40, 80, 128, .04);\n    position: relative;\n    overflow: hidden\n}\n\n.sc-home .persona:before {\n    content: \"\";\n    height: 4px;\n    background: linear-gradient(90deg, #0bbfae, #4a9ae9);\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%\n}\n\n.sc-home .persona.purple:before {\n    background: linear-gradient(90deg, #426cae, #2a899a)\n}\n\n.sc-home .persona-icon {\n    height: 49px;\n    width: 49px;\n    border-radius: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #e7f8f5;\n    color: #099c92;\n    margin-bottom: 20px;\n    font-size: 22px\n}\n\n.sc-home .persona.purple .persona-icon {\n    background: #eaf2fc;\n    color: #3b66a0\n}\n\n.sc-home .persona h3 {\n    font-size: 22px;\n    letter-spacing: -.6px;\n    margin-bottom: 10px\n}\n\n.sc-home .persona p {\n    color: var(--muted);\n    font-size: 13px;\n    line-height: 1.85;\n    margin-bottom: 20px\n}\n\n.sc-home .link-inline {\n    font-size: 12px;\n    font-weight: 750\n}\n\n.sc-home .persona.purple .link-inline {\n    color: #285d9d\n}\n\n.sc-home .feature-bar {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 18px;\n    margin-top: 18px\n}\n\n.sc-home .feature-mini {\n    display: flex;\n    gap: 12px;\n    padding: 19px;\n    background: #fff;\n    border: 1px solid var(--line);\n    border-radius: 15px;\n    align-items: flex-start\n}\n\n.sc-home .feature-mini .symbol {\n    font-size: 20px;\n    line-height: 1.2\n}\n\n.sc-home .feature-mini strong {\n    display: block;\n    font-size: 12px;\n    margin-bottom: 3px\n}\n\n.sc-home .feature-mini span {\n    font-size: 11px;\n    line-height: 1.6;\n    color: #79879a;\n    display: block\n}\n\n.sc-home .fig-wrap {\n    margin: 0;\n    border: 1px solid #e2e9f4;\n    background: white;\n    padding: 10px;\n    border-radius: 22px;\n    box-shadow: var(--shadow)\n}\n\n.sc-home .fig-wrap img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: auto;\n    border-radius: 14px;\n    object-fit: contain\n}\n\n.sc-home .fig-wrap figcaption {\n    color: #617188;\n    font-size: 12px;\n    line-height: 1.8;\n    padding: 15px 14px 10px\n}\n\n.sc-home .fig-wrap figcaption strong {\n    color: #234167\n}\n\n.sc-home .fig-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 22px\n}\n\n.sc-home .figure-label {\n    margin-bottom: 15px;\n    color: #4e6480;\n    font-size: 14px;\n    font-weight: 700\n}\n\n.sc-home .motion-panel {\n    background: linear-gradient(135deg, #ffffff, #f9fcff);\n    border: 1px solid #e1eaf7;\n    border-radius: 26px;\n    box-shadow: var(--shadow);\n    padding: 30px;\n    position: relative;\n    overflow: hidden\n}\n\n.sc-home .motion-toolbar {\n    display: flex;\n    gap: 14px;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-bottom: 24px\n}\n\n.sc-home .segment {\n    padding: 5px;\n    display: inline-flex;\n    gap: 3px;\n    border-radius: 12px;\n    background: #ecf2fa;\n    max-width: 100%\n}\n\n.sc-home .segment button {\n    border: 0;\n    cursor: pointer;\n    background: transparent;\n    color: #687b95;\n    padding: 10px 17px;\n    font-size: 12px;\n    font-weight: 740;\n    border-radius: 9px;\n    transition: background .2s\n}\n\n.sc-home .segment button[aria-selected=\"true\"] {\n    background: white;\n    color: #2069bc;\n    box-shadow: 0 2px 10px #d4e0f0\n}\n\n.sc-home .motion-caption {\n    font-size: 12px;\n    color: #8a9aaf\n}\n\n.sc-home .pause-btn {\n    border: 1px solid #dbe5f0;\n    background: #fff;\n    padding: 8px 13px;\n    font-size: 12px;\n    font-weight: 700;\n    color: #47647d;\n    border-radius: 10px;\n    cursor: pointer\n}\n\n.sc-home .flow-nodes {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 12px;\n    align-items: stretch\n}\n\n.sc-home .flow-node {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    min-height: 133px;\n    border: 1px solid #dfe8f5;\n    border-radius: 17px;\n    background: #fff;\n    padding: 14px 8px;\n    transition: border .25s, transform .25s, box-shadow .25s, background .25s;\n    cursor: pointer\n}\n\n.sc-home .flow-node.active {\n    border-color: #6ba9e7;\n    background: linear-gradient(160deg, #fff, #eff8ff);\n    box-shadow: 0 8px 30px rgba(44, 123, 219, .15);\n    transform: translateY(-4px)\n}\n\n.sc-home .flow-node.active:before {\n    content: \"\";\n    position: absolute;\n    height: 3px;\n    background: linear-gradient(90deg, #41a4e9, #20b9b6);\n    left: 20px;\n    right: 20px;\n    top: 0;\n    border-radius: 5px\n}\n\n.sc-home .flow-node:not(:last-child):after {\n    content: \"→\";\n    font-size: 19px;\n    color: #68a5de;\n    position: absolute;\n    right: -17px;\n    top: 43%;\n    z-index: 3;\n    font-weight: 800\n}\n\n.sc-home .flow-icon {\n    height: 45px;\n    width: 45px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #eff5fe;\n    color: #267acc;\n    font-size: 21px;\n    margin-bottom: 10px;\n    transition: background .2s\n}\n\n.sc-home .flow-node.active .flow-icon {\n    background: #d5ecfe\n}\n\n.sc-home .flow-node strong {\n    display: block;\n    font-size: 12px;\n    color: #20334e\n}\n\n.sc-home .flow-node small {\n    font-size: 10px;\n    color: #91a0b1;\n    margin-top: 4px\n}\n\n.sc-home .motion-detail {\n    margin-top: 22px;\n    background: #f1f7ff;\n    border: 1px solid #e2eefc;\n    border-radius: 14px;\n    min-height: 66px;\n    padding: 18px 20px;\n    color: #526d8e;\n    font-size: 13px;\n    display: flex;\n    gap: 18px;\n    align-items: center\n}\n\n.sc-home .motion-detail strong {\n    color: #215793;\n    white-space: nowrap\n}\n\n.sc-home .motion-detail span {\n    flex: 1\n}\n\n.sc-home .tiny-note {\n    font-size: 11px;\n    color: #8493a6;\n    margin-top: 14px;\n    margin-bottom: 0\n}\n\n.sc-home .steps-grid {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 14px\n}\n\n.sc-home .step {\n    border: 1px solid var(--line);\n    border-radius: 18px;\n    background: #fff;\n    padding: 20px 17px;\n    box-shadow: 0 4px 17px rgba(46, 80, 123, .04);\n    position: relative\n}\n\n.sc-home .step-num {\n    font-size: 11px;\n    letter-spacing: 1px;\n    color: #3583c9;\n    background: #e8f3ff;\n    border-radius: 9px;\n    display: inline-flex;\n    padding: 7px 10px;\n    font-weight: 760;\n    margin-bottom: 16px\n}\n\n.sc-home .step h3 {\n    font-size: 15px;\n    letter-spacing: -.2px;\n    line-height: 1.4;\n    margin: 0 0 8px\n}\n\n.sc-home .step p {\n    font-size: 12px;\n    color: #6e7e94;\n    line-height: 1.75;\n    margin: 0\n}\n\n.sc-home .code-panel {\n    border: 1px solid #dce7f4;\n    border-radius: 18px;\n    overflow: hidden;\n    background: #102039;\n    margin-top: 28px;\n    color: #e9f5ff;\n    box-shadow: 0 18px 34px rgba(25, 53, 100, .12)\n}\n\n.sc-home .code-head {\n    background: #1a2b49;\n    padding: 12px 18px;\n    border-bottom: 1px solid #314766;\n    font-size: 11px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #b0c5e4\n}\n\n.sc-home .code-dots {\n    display: flex;\n    gap: 6px\n}\n\n.sc-home .code-dots i {\n    background: #6594d0;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%\n}\n\n.sc-home .code-panel pre {\n    font-size: 13px;\n    line-height: 1.8;\n    white-space: pre-wrap;\n    padding: 20px 24px;\n    overflow: auto;\n    margin: 0;\n    font-family: \"SFMono-Regular\", Consolas, monospace\n}\n\n.sc-home .code-panel .kw {\n    color: #82d6fa\n}\n\n.sc-home .code-panel .string {\n    color: #adf1cf\n}\n\n.sc-home .copy-btn {\n    background: transparent;\n    border: 1px solid #52708e;\n    border-radius: 7px;\n    color: #d1e8f7;\n    padding: 5px 9px;\n    cursor: pointer;\n    font-size: 11px\n}\n\n.sc-home .guides {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 15px\n}\n\n.sc-home .guide {\n    display: block;\n    background: #fff;\n    border: 1px solid var(--line);\n    border-radius: 16px;\n    padding: 21px;\n    transition: transform .2s, box-shadow .2s;\n    min-height: 132px\n}\n\n.sc-home .guide:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 12px 32px rgba(33, 76, 125, .1);\n    text-decoration: none\n}\n\n.sc-home .guide-icon {\n    font-size: 21px;\n    display: block;\n    margin-bottom: 13px\n}\n\n.sc-home .guide strong {\n    display: block;\n    font-size: 14px;\n    color: var(--ink)\n}\n\n.sc-home .guide small {\n    display: block;\n    margin-top: 6px;\n    font-size: 11px;\n    color: #8090a4;\n    line-height: 1.7\n}\n\n.sc-home .bottomband {\n    padding: 75px 0;\n    background: radial-gradient(ellipse at 76% 20%, #eef2ff, transparent 54%), linear-gradient(125deg, #f4fbff, #fbfaff);\n    border-top: 1px solid #e8edf7;\n    border-bottom: 1px solid #e8edf7;\n    text-align: center\n}\n\n.sc-home .bottomband h2 {\n    font-size: 36px\n}\n\n.sc-home .bottomband .lead {\n    max-width: 650px;\n    margin: 0 auto 24px\n}\n\n.sc-home .footer {\n    padding: 30px 0 44px;\n    color: #8a9bad;\n    font-size: 11px\n}\n\n.sc-home .footer-flex {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 20px\n}\n\n\n\n\n\n@container sc-home (max-width: 960px) {\n    .sc-home .hero-grid {\n        gap: 28px\n    }\n\n    .sc-home .hero-art {\n        height: 380px\n    }\n\n    .sc-home .feature-bar {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .sc-home .steps-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr))\n    }\n\n    .sc-home .nav-links {\n        gap: 17px\n    }\n}\n\n@container sc-home (max-width: 640px) {\n    .sc-home .fig-grid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n\n@container sc-home (max-width: 730px) {\n    .sc-home .hero {\n        padding: 66px 0\n    }\n\n    .sc-home .hero-grid {\n        grid-template-columns: 1fr\n    }\n\n    .sc-home .hero-art {\n        max-width: 600px;\n        width: 100%;\n        margin: auto\n    }\n\n    .sc-home .two-cards {\n        grid-template-columns: 1fr\n    }\n\n    .sc-home .feature-bar {\n        grid-template-columns: 1fr\n    }\n\n    .sc-home .nav-links {\n        display: none;\n        position: absolute;\n        top: 77px;\n        right: 0;\n        left: 0;\n        background: white;\n        border-bottom: 1px solid var(--line);\n        padding: 19px 24px;\n        box-shadow: var(--shadow);\n        flex-direction: column;\n        align-items: stretch;\n        z-index: 10\n    }\n\n    .sc-home .nav-links.open {\n        display: flex\n    }\n\n    .sc-home .mobile-menu {\n        display: flex\n    }\n\n    .sc-home .stats {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .sc-home .stat:nth-child(2) {\n        border-right: 0\n    }\n\n    .sc-home .stat:nth-child(-n + 2) {\n        border-bottom: 1px solid #e1e9f3\n    }\n\n    .sc-home .stat:nth-child(3) {\n        padding-left: 0\n    }\n\n    .sc-home .sc-section {\n        padding: 75px 0\n    }\n\n    .sc-home .guides {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .sc-home .flow-nodes {\n        grid-template-columns: repeat(3, minmax(0, 1fr))\n    }\n\n    .sc-home .flow-node:not(:last-child):after {\n        display: none\n    }\n}\n\n@container sc-home (max-width: 490px) {\n    .sc-home .sc-container {\n        width: min(var(--content), calc(100% - 32px))\n    }\n\n    .sc-home h1 {\n        font-size: 45px;\n        letter-spacing: -2.1px\n    }\n\n    .sc-home .hero-art {\n        height: 300px\n    }\n\n    .sc-home .float-card {\n        transform: scale(.82) !important\n    }\n\n    .sc-home .float-card.top {\n        left: 7px;\n        top: 18px\n    }\n\n    .sc-home .float-card.bottom {\n        right: 7px;\n        bottom: 12px\n    }\n\n    .sc-home .hero-intro {\n        font-size: 15px\n    }\n\n    .sc-home .stats-caption {\n        text-align: center\n    }\n\n    .sc-home .stat {\n        padding: 15px\n    }\n\n    .sc-home .stat strong {\n        font-size: 22px\n    }\n\n    .sc-home .motion-panel {\n        padding: 19px 12px\n    }\n\n    .sc-home .segment {\n        width: 100%\n    }\n\n    .sc-home .segment button {\n        padding: 9px 8px;\n        font-size: 11px;\n        flex: 1\n    }\n\n    .sc-home .motion-toolbar {\n        justify-content: center\n    }\n\n    .sc-home .flow-nodes {\n        grid-template-columns: repeat(2, minmax(0, 1fr))\n    }\n\n    .sc-home .flow-node {\n        min-height: 114px\n    }\n\n    .sc-home .motion-detail {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 7px\n    }\n\n    .sc-home .steps-grid {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .sc-home .guides {\n        grid-template-columns: 1fr\n    }\n\n    .sc-home .fig-wrap {\n        padding: 5px\n    }\n\n    .sc-home .fig-wrap figcaption {\n        padding: 12px\n    }\n\n    .sc-home .bottomband h2 {\n        font-size: 30px\n    }\n\n    .sc-home .sc-cta {\n        padding: 11px 15px;\n        font-size: 12px\n    }\n}\n\n@media (prefers-reduced-motion:reduce) {\n\n    .sc-home *,\n    .sc-home *:before,\n    .sc-home *:after {\n        animation: none !important;\n        transition: none !important;\n        scroll-behavior: auto !important\n    }\n}\n\n/* Host page integration: never change surrounding right/left rail layout. */\n.sc-home {\n    max-width: 100%;\n    min-width: 0;\n    width: 100%;\n    overflow-x: clip;\n    background: white;\n    font-size: 16px;\n}\n\n.sc-home .sc-container {\n    width: min(var(--content), calc(100% - 36px));\n}\n\n.sc-home figure {\n    margin-block: 0;\n}\n\n.sc-home .fig-wrap img {\n    image-rendering: auto;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n\n.sc-home section[id] {\n    scroll-margin-top: 20px;\n}\n\n.sc-home button:focus-visible,\n.sc-home a:focus-visible {\n    outline: 3px solid #2895c6;\n    outline-offset: 3px;\n}\n\n@container sc-home (max-width: 650px) {\n    .sc-home .sc-container {\n        width: calc(100% - 28px);\n    }\n}\n\n/* ======================================================================\n   APP.CSS / NAVBAR.CSS INTEGRATION FIXES\n   These declarations affect only getStarted.js; other page styles remain intact.\n   All layout breakpoints above are container queries, based on THIS page's\n   actual width, not the full browser viewport.\n   ====================================================================== */\n.sc-home {\n    /* This page can be rendered inside a narrow grid column. */\n    container: sc-home / inline-size;\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    min-height: 0;\n    height: auto;\n    isolation: isolate;\n    overflow-x: clip;\n    color: #13223e;\n    background: #fff;\n    text-align: left;\n}\n\n.sc-home .sc-container {\n    /* NEVER use App.css' generic .container: its height:100vh caused\n       enormous empty spaces and layout overflow on every section. */\n    display: block;\n    position: relative;\n    width: min(100% - 36px, var(--content));\n    max-width: 100%;\n    min-height: 0;\n    height: auto;\n    margin-inline: auto;\n    padding: 0;\n}\n\n.sc-home .sc-section {\n    display: block;\n    min-width: 0;\n    width: 100%;\n    height: auto;\n    padding-block: clamp(36px, 5cqw, 72px);\n}\n\n.sc-home main {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    display: block;\n    margin: 0;\n    padding: 0;\n    height: auto;\n}\n\n.sc-home .two-cards,\n.sc-home .feature-bar,\n.sc-home .fig-grid,\n.sc-home .steps-grid,\n.sc-home .guides,\n.sc-home .flow-nodes {\n    min-width: 0;\n}\n\n.sc-home .two-cards > *,\n.sc-home .feature-bar > *,\n.sc-home .fig-grid > *,\n.sc-home .steps-grid > *,\n.sc-home .guides > *,\n.sc-home .flow-nodes > * {\n    min-width: 0;\n}\n\n.sc-home .fig-grid {\n    /* Figures share the row at desktop/content widths; image links allow full-size inspection. */\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n    max-width: none;\n    margin-inline: 0;\n    align-items: stretch;\n    gap: 20px;\n}\n\n.sc-home .fig-wrap {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    height: auto;\n    overflow: hidden;\n}\n\n.sc-home .fig-wrap img {\n    /* Remove the old wrong 745:402 aspect ratio; actual files are 4:3. */\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    max-height: none;\n    aspect-ratio: auto;\n    object-fit: contain;\n    margin: 0 auto;\n}\n\n.sc-home .sc-cta {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px 19px;\n    gap: 8px;\n    text-decoration: none;\n    font-weight: 730;\n    font-size: 13px;\n    line-height: 1.5;\n    border: 1px solid transparent;\n    border-radius: 12px;\n    cursor: pointer;\n    white-space: normal;\n}\n.sc-home .sc-cta.primary {\n    color: #fff;\n    background: linear-gradient(115deg, #0c509b, #186ba7);\n    box-shadow: 0 11px 25px rgba(43, 93, 207, .2);\n}\n.sc-home .sc-cta.primary:hover {\n    color: #fff;\n    text-decoration: none;\n    box-shadow: 0 14px 28px rgba(43, 93, 207, .27);\n}\n\n/* App.css styles .main-content pre and code for Markdown pages. Ensure\n   this native JSX code example retains its intentional dark styling. */\n.sc-home .code-panel pre {\n    display: block;\n    background: transparent;\n    color: #e9f5ff;\n    border: 0;\n    border-radius: 0;\n    margin: 0;\n    padding: 20px 24px;\n    max-width: 100%;\n    overflow-x: auto;\n    overflow-wrap: normal;\n    white-space: pre;\n    font-size: 13px;\n    line-height: 1.8;\n}\n.sc-home .code-panel pre code {\n    color: inherit;\n    background: transparent;\n    border: 0;\n    padding: 0;\n    font: inherit;\n    white-space: inherit;\n}\n.sc-home .code-panel .kw { color: #82d6fa; }\n.sc-home .code-panel .string { color: #adf1cf; }\n\n/* Use actual component width; a 1200px browser may provide only 700px\n   to this page after the surrounding navigation rails are laid out. */\n@container sc-home (max-width: 1040px) {\n    .sc-home .steps-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n    .sc-home .feature-bar { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n@container sc-home (max-width: 780px) {\n    .sc-home .two-cards { grid-template-columns: minmax(0, 1fr); }\n    .sc-home .feature-bar { grid-template-columns: minmax(0, 1fr); }\n    .sc-home .flow-nodes { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n    .sc-home .flow-node:not(:last-child):after { display: none; }\n    .sc-home .steps-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n    .sc-home .guides { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n    .sc-home .motion-panel { padding: 20px; }\n    .sc-home .sc-container { width: calc(100% - 28px); }\n}\n@container sc-home (max-width: 500px) {\n    .sc-home .steps-grid { grid-template-columns: minmax(0, 1fr); }\n    .sc-home .guides { grid-template-columns: minmax(0, 1fr); }\n    .sc-home .flow-nodes { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n    .sc-home .fig-wrap { padding: 5px; }\n    .sc-home .fig-wrap figcaption { padding: 12px; }\n    .sc-home .segment { width: 100%; }\n    .sc-home .segment button { flex: 1 1 auto; min-width: 0; padding: 9px 7px; }\n    .sc-home .motion-toolbar { justify-content: center; }\n    .sc-home .motion-detail { display: block; }\n    .sc-home .motion-detail strong { display: block; margin-bottom: 8px; white-space: normal; }\n    .sc-home .sc-container { width: calc(100% - 24px); }\n    .sc-home .code-panel pre { padding: 14px; font-size: 11px; }\n}\n\n/* When the existing three-column Get Started shell is used on narrow\n   screens, its 15% / 65% / 20% grid leaves too little space for the page.\n   Affect ONLY the shell containing this component; other routes and the\n   shared navbar remain unchanged. */\n@media (max-width: 900px) {\n    .getStarted-container:has(.sc-home) {\n        grid-template-columns: minmax(0, 1fr);\n    }\n    .getStarted-container:has(.sc-home) > .left-nav,\n    .getStarted-container:has(.sc-home) > .right-rail {\n        display: none;\n    }\n    .getStarted-container:has(.sc-home) > .main-content,\n    .getStarted-container:has(.sc-home) > .main-content-no-scroll {\n        min-width: 0;\n        padding: 12px;\n        overflow-x: clip;\n    }\n}\n\n/* Keep headings and subsequent content separate at every host width.\n   All selectors are scoped; App.css and navbar.css remain untouched. */\n.sc-home .sc-section-heading + .two-cards,\n.sc-home .sc-section-heading + .fig-grid,\n.sc-home .sc-section-heading + .motion-panel,\n.sc-home .sc-section-heading + .steps-grid,\n.sc-home .sc-section-heading + .guides,\n.sc-home .sc-section-heading + .fig-wrap {\n    position: relative;\n    clear: both;\n    min-width: 0;\n}\n@container sc-home (max-width: 600px) {\n    .sc-home .sc-section-heading { row-gap: 11px; margin-bottom: 25px; }\n    .sc-home .sc-section-heading > h2 { font-size: clamp(24px, 5.1cqw, 34px); }\n    .sc-home .sc-section-heading > p.lead { font-size: 13px; }\n}\n\n/* Platform diagrams: two equal columns in the existing main-content region.\n   Breakpoints use the page container's width, so the host's left/right rails\n   do not cause accidental side-by-side overflow. */\n.sc-home #architecture .fig-grid.fig-grid--side-by-side {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: stretch;\n    gap: clamp(12px, 2cqw, 24px);\n    width: 100%;\n    max-width: none;\n}\n.sc-home #architecture .fig-grid--side-by-side > .fig-wrap {\n    min-width: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n}\n.sc-home #architecture .fig-grid--side-by-side .fig-image-link {\n    display: block;\n    width: 100%;\n    border-radius: 14px;\n    overflow: hidden;\n}\n.sc-home #architecture .fig-grid--side-by-side .fig-image-link img {\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    object-fit: contain;\n}\n.sc-home #architecture .fig-grid--side-by-side figcaption {\n    flex: 1;\n}\n@container sc-home (max-width: 640px) {\n    .sc-home #architecture .fig-grid.fig-grid--side-by-side {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n\n\n/* Python code example: preserve intentional line breaks from React text nodes,\n   avoid host Markdown/pre styling, and keep Copy usable on small screens. */\n.sc-home .code-panel {\n    min-width: 0;\n    max-width: 100%;\n}\n\n.sc-home .code-panel .code-head {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    gap: 12px;\n    align-items: center;\n    min-width: 0;\n}\n\n.sc-home .code-panel .code-title {\n    min-width: 0;\n    text-align: center;\n    overflow-wrap: anywhere;\n}\n\n.sc-home .code-panel .code-dots {\n    flex-shrink: 0;\n}\n\n.sc-home .code-panel pre.sc-code-pre {\n    display: block;\n    min-width: 0;\n    max-width: 100%;\n    padding: 18px 24px;\n    margin: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    background: transparent;\n    color: #e9f5ff;\n    font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", monospace;\n    font-size: 13px;\n    line-height: 1.9;\n    white-space: pre;\n    word-break: normal;\n    overflow-wrap: normal;\n    tab-size: 4;\n}\n\n.sc-home .code-panel pre.sc-code-pre code.sc-code-text {\n    display: block;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n    margin: 0;\n    color: inherit;\n    font: inherit;\n    white-space: pre;\n    word-break: normal;\n    overflow-wrap: normal;\n    user-select: text;\n    -webkit-user-select: text;\n}\n\n.sc-home .code-panel pre.sc-code-pre .kw { color: #82d6fa; }\n.sc-home .code-panel pre.sc-code-pre .string { color: #adf1cf; }\n\n.sc-home .code-panel .copy-btn {\n    min-width: 78px;\n    min-height: 34px;\n    padding: 7px 12px;\n    white-space: nowrap;\n    font: inherit;\n    font-size: 12px;\n    line-height: 1.4;\n    cursor: pointer;\n    background-color: #203a5b;\n    color: #e9f5ff;\n}\n.sc-home .code-panel .copy-btn:hover { background-color: #2d507c; }\n.sc-home .code-panel .copy-btn:focus-visible {\n    outline: 2px solid #8ad5ff;\n    outline-offset: 2px;\n}\n\n@container sc-home (max-width: 540px) {\n    .sc-home .code-panel .code-head {\n        grid-template-columns: minmax(0, 1fr) auto;\n        gap: 8px;\n        padding: 12px;\n    }\n    .sc-home .code-panel .code-dots { display: none; }\n    .sc-home .code-panel .code-title { text-align: left; }\n    .sc-home .code-panel pre.sc-code-pre {\n        padding: 16px 14px;\n        font-size: 11px;\n    }\n    .sc-home .code-panel .copy-btn {\n        padding: 7px 9px;\n        min-width: 56px;\n        font-size: 11px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
